import React from 'react';

import { ArchivalUnitCopy, EadNode } from 'types';

import { ArchivalUnitFields } from './archival-unit-fields';

export function ArchivalAidChildrenDetail({
  item,
  ...rest
}: {
  item?: ArchivalUnitCopy | EadNode;
}) {
  return <ArchivalUnitFields item={item as ArchivalUnitCopy} />;
}
